export default "__VITE_ASSET__DNtHj7Wq__"